export default __webpack_public_path__ + "static/media/stunningpunch5.5bc0da25.png";